var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeLightStopped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#222222",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 12C18.6716 12 18 12.6716 18 13.5V20.5C18 21.3284 18.6716 22 19.5 22C20.3284 22 21 21.3284 21 20.5V13.5C21 12.6716 20.3284 12 19.5 12ZM24.5 12C23.6716 12 23 12.6716 23 13.5V20.5C23 21.3284 23.6716 22 24.5 22C25.3284 22 26 21.3284 26 20.5V13.5C26 12.6716 25.3284 12 24.5 12Z",
    fill: "#222222",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLightStopped);
export default __webpack_public_path__ + "static/media/we-light-stopped.31da9337a330ccd93af8afbbbc399e09.svg";
export { ForwardRef as ReactComponent };